import { render } from "./UniqueCodesBulkData.vue?vue&type=template&id=1b45e59a"
import script from "./UniqueCodesBulkData.vue?vue&type=script&lang=js"
export * from "./UniqueCodesBulkData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__